import React, { ReactElement } from 'react';
import { TabConfig } from '@odin-labs/components';
import { to } from 'acl';
import { AuthContext } from 'auth';
import { AuthUser } from 'auth/types';
import { RoutedTabsPages, useRoutedTabs } from 'components/tabs';
import { NewHeader } from 'components/header/NewHeader';
import { ensureNonEmptyItems } from 'utils';

import { Container } from 'components/container';
import { ExternalConnections } from 'containers/settings/tabs/externalConnections/ExternalConnections';
import { useFlags } from 'featureFlags';
import { GeneralInformation, JobsiteInformation, Security } from './tabs';

const baseRoute = '/settings';

const getTabsConfig = (
  user: AuthUser,
  externalConnectionsEnabled: boolean,
): TabConfig[] =>
  ensureNonEmptyItems<TabConfig>([
    { name: 'General', relativePath: '', component: GeneralInformation },
    {
      name: 'Jobsites',
      relativePath: '/jobsites',
      component: JobsiteInformation,
    },
    externalConnectionsEnabled && {
      name: 'External Connections',
      relativePath: '/external-connections',
      component: ExternalConnections,
    },
    user.isAllowed(to.manageUserPin) && {
      name: 'Security',
      relativePath: '/security',
      component: Security,
    },
  ]);

export function SettingsContainer(): ReactElement {
  const { currentUser: user } = React.useContext(AuthContext);
  const { procoreSelfServiceEnabled } = useFlags();
  const tabsConfig = getTabsConfig(user, procoreSelfServiceEnabled);
  const { tabs, currentTab } = useRoutedTabs({ tabsConfig, baseRoute });

  return (
    <Container className="settings-container">
      <NewHeader title="Settings" tabsProps={{ tabs, currentTab }} />
      <RoutedTabsPages baseRoute={baseRoute} tabs={tabs} />
    </Container>
  );
}
